<template>
    <div
        class="fixed hidden bottom-0 left-0 z-30 w-full py-3 bg-white border-t border-gp-grey-40 no-print max-lg:block">
        <div class="container max-md:px-3.75 grid h-full max-w-lg grid-cols-5 mx-auto">
            <router-link class="icon-nav text-xss" :to="{ name: 'mallCategories' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconGrid></IconGrid>
                    {{ $t('page.categories') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss" :to="{ name: 'brands' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconBrand></IconBrand>
                    {{ $t('nav.brands') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss" :to="{ name: 'products' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconBox></IconBox>
                    {{ $t('page.products') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss" :to="{ name: 'stores' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconStore></IconStore>
                    {{ $t('nav.stores') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss relative" :to="{ name: 'cart' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconCart></IconCart>
                    {{ $t('nav.cart') }}
                </div>
            </router-link>
        </div>
    </div>
</template>

<script setup>
import IconGrid from '@icons/IconGrid.vue'
import IconStore from '@icons/IconStore.vue'
import IconUser from '@icons/IconUser.vue'
import IconCart from '@icons/IconCart.vue'
import IconBrand from '@icons/IconBrand.vue'
import IconBox from '@icons/IconBox.vue'
</script>

<style>

</style>

<style scoped>
.router-link-exact-active{
    color: #409DBA;
}

</style>